import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import FooterBottom from "./FooterBottom";
import { JNTUK_PDF_Links } from "../../../utils/api.config";
import { imageBaseURL } from "../../../utils/fetchData";

import univBuilding1 from "../../../assets/img/univ-building/1.jpg";
import univBuilding2 from "../../../assets/img/univ-building/2.jpg";
import univBuilding3 from "../../../assets/img/univ-building/3.jpg";
import univBuilding4 from "../../../assets/img/univ-building/4.jpg";
import univBuilding5 from "../../../assets/img/univ-building/5.jpg";
import univBuilding6 from "../../../assets/img/univ-building/6.jpg";
import univBuilding7 from "../../../assets/img/univ-building/7.jpg";
import univBuilding8 from "../../../assets/img/univ-building/8.jpg";

const photos = [
    {
      src: univBuilding1,
      width: 4,
      height: 3
    },
    {
      src: univBuilding2,
      width: 4,
      height: 3
    },
    {
      src: univBuilding3,
      width: 4,
      height: 3
    },
    {
      src: univBuilding4,
      width: 4,
      height: 3
    },
    {
      src: univBuilding5,
      width: 4,
      height: 3
    },
    {
      src: univBuilding6,
      width: 4,
      height: 3
    },
    {
      src: univBuilding7,
      width: 4,
      height: 3
    },
    {
      src: univBuilding8,
      width: 4,
      height: 3
    }
  ];

const Footer = (props) => {
  const { footerLogo, footerClass, footerTopClass } = props;
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  const externalLink = (url) => {
    const userConfirmed = window.confirm(
      "You are being redirected to an external website. Please note that JNTUK Portal is not responsible for external websites content & privacy policies."
    );
    
    if (userConfirmed) {
      window.open(url, "_blank");
    } else {

    }
  };
  const subDomain = (url) => {
    // const userConfirmed = window.confirm(
    //   "You are being redirected to an internal sub-domain website. The sub-domain website will open in a New Tab"
    // );
    
    // if (userConfirmed) {
      window.open(url, "_blank");
    // } else {

    // }
  };
  return (
    <footer className={footerClass ? footerClass : "rs-footer home9-style main-home"}>
      <div className="footer-container-ts"></div>
      <div className="container">
        <div className="footer-top-social">
          <div className="row y-middle">
            <div className="social_msg col-md-6">Stay Connected!</div>
            <div className="social_icon_container col-md-6">
              <ul className="social_icon">
                <li className="facebook">
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="twitter">
                  <a href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li className="google-plus">
                  <a href="#">
                    <i className="fab fa-google-plus"></i>
                  </a>
                </li>
                <li className="pinterest">
                  <a href="#">
                    <i className="fab fa-pinterest"></i>
                  </a>
                </li>

                <li className="linkedin">
                  <a href="#">
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
                <li className="instagram">
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="youtube">
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-center">
        <div className="container">
          <div className="row y-middle">
            <div className="col-md-4">
              <h3 title="Communication Address">Communication Address</h3>
              <h4 title="The Registrar">The Registrar</h4>
              <p>Jawaharlal Nehru Technological University Kakinada</p>
              <p>Kakinada, Andhra Pradesh 533003</p>
              <p className="mt-20">Phone: +91 884 230 0900</p>
              <p>Fax: +91 884 230 0901</p>
              <div className="rs-gallery mt-20">
                <Gallery columns='4'
                  direction={"column"}
                  photos={photos}
                  onClick={openLightbox}

                />
                <ModalGateway>
                  {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                      <Carousel
                        currentIndex={currentImage}
                        views={photos.map(x => ({
                          ...x,
                          srcset: x.srcSet,
                          caption: x.title
                        }))}
                      />
                    </Modal>
                  ) : null}
                </ModalGateway>
              </div>
            </div>
            <div className="col-md-8">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d238.49542931082723!2d82.24262115491288!3d16.97814717257171!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a38299cdd8f2049%3A0xb7251fd704659869!2sJawaharlal%20Nehru%20Technological%20University%2C%20Kakinada!5e0!3m2!1sen!2sin!4v1706180831314!5m2!1sen!2sin"
                width="100%"
                height="320"
                allowFullScreen=""
                aria-hidden="false"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className={`footer-top ${footerTopClass}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12 col-sm-12 footer-widget md-mb-50">
              <h3 className="widget-title" title="About JNTUK">About JNTUK</h3>
              <ul className="site-map">
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision`} } target="_blank">Vision & Mission</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses`} } target="_blank">Research and Ranking</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SDD`} } target="_blank">Strategy Development and Deployment</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/institutional-bodies`} } target="_blank">Institutional Bodies</Link>
                </li>
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.JNTU_Act_Link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    JNTU Act
                  </a>
                </li>
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.RTI_Act_Link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RTI Act
                  </a>
                </li>
                <li>
                  {" "}
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Tie-ups-and-Mou’s`} } target="_blank">Tie Ups & MOU's</Link>
                </li>
              </ul>

              <h3 className="widget-title mt-10" title="Academics">Academics</h3>
              <ul className="site-map">
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/programmes-offered`} } target="_blank">Courses Offered</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/admissions`} } target="_blank">Admissions</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/under-graduate`} } target="_blank">Affiliated Colleges</Link>
                </li>
                {/* <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`} } target="_blank">Academic Regulations</Link>
                </li> */}
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Calendars`} } target="_blank">
                    Academic Calendars
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Syllabus`} } target="_blank">Syllabus</Link>
                </li>
              </ul>

              <h3 className="widget-title mt-10" title="OTHER IMPORTANT LINKS">OTHER IMPORTANT LINKS</h3>
              <div className="inlineLinks">
                <button onClick={() => externalLink("https://www.ugc.gov.in/")}>
                  UGC
                </button>
                <button
                  onClick={() => externalLink("https://www.aicte-india.org/")}
                >
                  AICTE
                </button>
                <button
                  onClick={() => externalLink("https://apsche.ap.gov.in/")}
                >
                  APSCHE
                </button>
                <button
                  onClick={() =>
                    externalLink(
                      "https://cets.apsche.ap.gov.in/ECET/ECET/ECET_HomePage.aspx"
                    )
                  }
                >
                  AP ECET
                </button>
                <button
                  onClick={() =>
                    externalLink(
                      "https://cets.apsche.ap.gov.in/PGECET/PGECET/PGECET_HomePage.aspx"
                    )
                  }
                >
                  AP PGECET
                </button>
                <button
                  onClick={() =>
                    externalLink(
                      "https://cets.apsche.ap.gov.in/EAPCET/Eapcet/EAPCET_HomePage.aspx"
                    )
                  }
                >
                  AP EAPCET
                </button>
              </div>

              <h3 className="widget-title mt-10" title="OTHER JNTUK PORTALS">OTHER JNTUK PORTALS</h3>
              <div className="inlineLinks">
                <button onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/category/Sports`)}>
                  Sports
                </button>
                <button onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/category/Placement-Notifications`)}>
                  Placements
                </button>
                <button
                  onClick={() => subDomain("https://jntukdaaportal.org/")}
                >
                  DAA
                </button>
                <button onClick={() => subDomain("https://jntukdmc.in/")}>
                  DMC
                </button>
                <button
                  onClick={() => subDomain("https://jntukelearn.in/elearn/")}
                >
                  Jntuk eLearn
                </button>
                <button
                  onClick={() =>
                    subDomain(
                      "https://www.ugc.gov.in/Error/Error_404?aspxerrorpath=/video.aspx"
                    )
                  }
                >
                  UGC SWAYAM - TVCS & RADIO JINGLES FOR SWAYAM INITIATIVE
                </button>
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 footer-widget md-mb-50">
              <h3 className="widget-title" title="Administration">Administration</h3>
              <ul className="site-map">
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/chancellor`} } target="_blank">Chancellor</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/vice-chancellor`} } target="_blank">Vice Chancellor</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/rector`} } target="_blank">Rector</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/osd`} } target="_blank">OSD</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/registrar`} } target="_blank">Registrar</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/executive-council`} } target="_blank">Executive Council</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academic-senate`} } target="_blank">Academic Senate</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/board-of-studies`} } target="_blank">Board of Studies</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/governing-hierarchy`} } target="_blank">Governing Heirarchy</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/directorates`} } target="_blank">Directorates</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 footer-widget md-mb-50">
            <h3 className="widget-title" title="Directorates">Directorates</h3>
              <ul className="site-map">
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/academics-and-planning-dap`} } target="_blank">
                   Director, Academic Planning
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/admissions-da`} } target="_blank">Director, Admissions</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/infrastructure-development`} } target="_blank">
                    Chief Engineer & Director, Infrastructure Development
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-incubation`} } target="_blank">Director (i/c) Incubation</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-foreign-university-relations-dfur`} } target="_blank">
                    Director, Foreign University Relations
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-university-games-and-sports`} } target="_blank">
                    Director, University Games & Sports
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/institute-of-science-and-technology-ist`} } target="_blank">
                    Director, IST
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/faculty-development-centre`} } target="_blank">
                    Director – Faculty Development Centre
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-bics`} } target="_blank">Director, BICS</Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-industry-institute-interaction-placements-and-training`} } target="_blank">
                    Director, IIIP & Training
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-empowerment-of-women-grievances`} } target="_blank">
                    Director, Empowerment of Women & Grievances
                  </Link>
                </li>
                <li>
                  <Link to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/school-of-management-studies`} } target="_blank">
                    Director – School of Management Studies
                  </Link>
                </li>
                <li>
                  <Link onClick={() => externalLink("https://jntukbiotech.com")}>
                    Biotech
                  </Link>
                </li>
                <li>
                  <Link onClick={() => externalLink("https://jntukfoodtech.com")}>
                    Foodtech
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 footer-widget">
            <h3 className="widget-title" title="Institute of Science & Technology">Institute of Science & Technology</h3>
              <ul className="site-map">
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/shsr`)}> School of Health Sciences and Research</Link>
                    </li>
                    <li>
                      <Link  onClick={() => externalLink("https://jntukfoodtech.com")}> School of Food Technology</Link>
                    </li>
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/sree`)}>
                        School of Renewable Energy & Environment
                      </Link>
                    </li>
                    <li>
                      <Link  onClick={() => externalLink("https://jntukbiotech.com")}> School of Biotechnology </Link>
                    </li>
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/soa`)}>School of Avionics </Link>
                    </li>
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/ssit`)}>
                        School of Spatial Information Technology
                      </Link>
                    </li>
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/sopst`)}>
                        School of Pharmaceutical Sciences & Technologies
                      </Link>
                    </li>
                    <li>
                      <Link  onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/snt`)}> School of Nano Technology</Link>
                    </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
      
      <FooterBottom />
    </footer>
  );
};

export default Footer;
